<template>
  <div id="app">
    <router-view/>
    <GlobalWatermark />
  </div>
</template>

<script>
import GlobalWatermark from '@/components/GlobalWatermark.vue'

export default {
  name: 'App',
  components: { GlobalWatermark }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html, body {
  height: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#app {
  height: 100%;
}
</style>